import { createFeatureScope } from 'bundles/product-features';

export const { ProductFeaturesQuery, withProductFeatures, useProductFeatures } = createFeatureScope({
  commerceMonetization: {
    excludeLearnerSubscribedPriorToCurrentMonetizationExperiment: false,
  },
  globalPayments: {
    enableFinancialAidLink: true,
    enablePartnerSupportedAccess: false,
  },
});
